export enum UserStatus {
  ACTIVE = 'active',
  MERGED = 'merged',
  DELETED = 'deleted',
}
